import {LitElement, html} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement( 'im-user-avatar' )
export class UserAvatar extends LitElement {

  @property()
  initials: string;

  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div
        class="user-avatar w-10 h-10 rounded-full flex-shrink-0 p-0.5 border-2 border-light-primary dark:border-dark-primary bg-transparent"
      >
        <span
          class="flex items-center justify-center w-full h-full bg-light-primary dark:bg-dark-primary text-white rounded-full font-medium"
        >
          ${ this.initials }
        </span>
      </div>
    `;
  }
}
